// extracted by mini-css-extract-plugin
export default {"submenuItem":"SubmenuItem_submenuItem__DUFgF","content":"SubmenuItem_content__D8HRO","text":"SubmenuItem_text__im0aS"};